export function detectCsvDataType(columns) {
  if (!columns || columns.length === 0) return 'generic';
  const colsJoined = columns.map((c) => String(c).toLowerCase()).join(' ');
  const mlKeywords = [
    'epoch',
    'loss',
    'val_',
    'train/',
    'train_',
    'lr/',
    'lr_',
    'map',
    'precision',
    'recall',
    'accuracy',
    'seg_loss',
    'box_loss',
    'cls_loss',
    'metrics',
  ];
  const salesKeywords = [
    'revenue',
    'quantity',
    'unit_price',
    'unit price',
    'region',
    'product',
    'customer',
    'transaction',
    'order',
    'sales',
    'price',
  ];
  if (mlKeywords.some((kw) => colsJoined.includes(kw))) return 'ml_scientific';
  if (salesKeywords.some((kw) => colsJoined.includes(kw))) return 'sales';
  return 'generic';
}

export const DATA_TYPE_LABELS = {
  ml_scientific: 'ML / Scientific',
  sales: 'Sales',
  generic: 'Generic',
};
